var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app-bar',{attrs:{"app":""}},[_c('v-toolbar-title',[_c('span',[_vm._v("Tickets")])]),_c('v-spacer'),(_vm.$route.path === '/tickets')?_c(_setup.ButtonExcel):_c(_setup.ButtonPrintTicket)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }